/** 讨论组分类相关接口 */
import http from "@/utils/http";
import { env } from "@/utils";
import { objectToUrlParams } from "@/utils/url";
import { objectToFormdata } from "@/utils";
// 创建收藏
export function addChatClass(params) {
  return http({
    baseURL: "/",
    method: "PUT",
    url: `rest/v5/collect/chat`,
    withCredentials: false,
    data: objectToUrlParams(params),
  });
}
// 创建多个收藏
export function addChatClassMulti(params) {
  return http({
    baseURL: "/",
    method: "PUT",
    url: `rest/v5/collect/chat/multi`,
    withCredentials: false,
    data: params,
  });
}
// 收藏列表
export function chatClassList(params) {
  if (params && params.id) {
    return http({
      baseURL: "/",
      method: "GET",
      url: `/rest/v5/collect/chat/list?parentId=${params.id}`,
      withCredentials: false,
      params: params,
    });
  } else if (params && params.searchClassValue) {
    let url = params.parentId
      ? `/rest/v5/collect/chat/list?searchWords=${params.searchClassValue}&parentId=${params.parentId}`
      : `/rest/v5/collect/chat/list?searchWords=${params.searchClassValue}`;
    return http({
      baseURL: "/",
      method: "GET",
      url,
      withCredentials: false,
      params: params,
    });
  } else {
    return http({
      baseURL: "/",
      method: "GET",
      url: `/rest/v5/collect/chat/list`,
      withCredentials: false,
      params: params,
    });
  }
}
// 删除收藏
export function deleteClass(params) {
  return http({
    baseURL: "/",
    method: "DELETE",
    url: `/rest/v5/collect/chat/${params.id}`,
    withCredentials: false,
    data: params,
  });
}

// 复制收藏
export function copyClass(groupId) {
  return http({
    baseURL: "/",
    method: "PUT",
    url: `rest/v5/collect/chat/group/${groupId}`,
    withCredentials: false,
  });
}

// 修改文件夹名称
export function modifyClassName(id, params) {
  return http({
    baseURL: "/",
    method: "POST",
    url: `/rest/v5/collect/chat/modify/${id}`,
    withCredentials: false,
    data: objectToUrlParams(params),
  });
}

// 移动收藏文件夹
export function moveClass(params) {
  return http({
    baseURL: "/",
    method: "POST",
    url: `/rest/v5/collect/chat/modify/move/${params.id}`,
    withCredentials: false,
    data: objectToUrlParams(params),
  });
}

// 查询所有已经收藏的群&人
export function allCollect() {
  return http({
    baseURL: "/",
    method: "GET",
    url: `/rest/v5/collect/chat/all_collect`,
    withCredentials: false,
  });
}

// 收藏详情
export function collectInfo(params) {
  return http({
    baseURL: "/",
    method: "GET",
    url: `/rest/v5/collect/chat/info/${params}`,
    withCredentials: false,
  });
}

// 未被收藏的群组列表
export function listOfUnclassifiedGroups(params) {
  return http({
    baseURL: "/",
    method: "GET",
    url: `/rest/v5/collect/chat/none/list`,
    withCredentials: false,
    params: params,
  });
}
// 未被收藏的邮件列表
export function listOfUnclassifiedEmails(data) {
  return http({
    baseURL: "/",
    method: "POST",
    url: `${env("MAIL_BASEURL")}/mail/uncollect-messages`,
    withCredentials: false,
    data: objectToFormdata(data),
  });
}
